import { useState } from 'react';

export default values => {
  const [toggleButtons, setToggleButtons] = useState(
    values.map(item => ({ name: item, active: false }))
  );

  const handleToggleClick = idx => {
    const prevButton = toggleButtons[idx];
    const nextButtons = [...toggleButtons];
    nextButtons[idx] = { ...prevButton, active: !prevButton.active };
    setToggleButtons(nextButtons);
  };

  return [toggleButtons, handleToggleClick, setToggleButtons];
};
